import { importWhenVisible } from '@studiometa/js-toolkit';
import Panel from '../Panel.js';

/**
 * Cart component
 * @see https://liquid-ajax-cart.js.org/v2/
 */
export default class Cart extends Panel {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Cart',
    components: {
      CrossSell: (app) =>
        importWhenVisible(() => import('../../Sections/Slider/index.js'), 'CrossSell', app),
    },
  };

  /**
   * mounted
   */
  mounted() {
    document.addEventListener('liquid-ajax-cart:request-end', (event) => {
      const { requestState } = event.detail;

      // If the "add to cart" request is successful
      if (requestState.requestType === 'add' && requestState.responseData?.ok) {
        this.openPanel();
      }

      if (!requestState.responseData?.ok) {
        this.$root.Toaster.addToast(requestState.responseData?.body?.message);
      }

      this.$update();
    });

    super.mounted();
  }
}
